import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Flex, Modal, Spin, Tooltip, Typography } from 'antd'
import { useState } from 'react'
import { ContentPart } from '../../../components/content-part/ContentPart'
import { PageHeader } from '../../../components/page-header'
import { EntRole } from '../../../models/role'
import { AddRoleModal } from './AddRoleModal'
import { useRoles } from './useRoles'
import { useTranslation } from 'react-i18next'
import { EntInitialFilterName } from '../../../models/filters/initialFilterName'
import { useLazyGetRolesListQuery } from '../../../redux/api/rolesApi/roles'
import { useGetDataOnScroll } from '../../../components/getDataOnScrollProps/useGetDataOnScrollProps'
import _ from 'lodash'

export const Roles = () => {
	const [getData] = useLazyGetRolesListQuery()
	const { fetching, data, filter, access, setData, setFetching, setFilter, setCurrentPage } =
		useGetDataOnScroll<EntRole, EntInitialFilterName>({
			initialFilter: new EntInitialFilterName(),
			query: getData,
		})

	const [modal, contextHolder] = Modal.useModal()
	const { t } = useTranslation()
	const [selectedRole, setSelectedRole] = useState<EntRole>(new EntRole())
	const [showModal, setShowModal] = useState<boolean>(false)
	const { onAddRole, onEditRole, onDeleteRole } = useRoles(modal, () => {
		searchHandleClick()
	})
	const [height, setHeight] = useState<number>(0)
	const openAddModal = (role: EntRole) => {
		setSelectedRole(role)
		setShowModal(true)
	}
	const setEntityFromFields = (): EntInitialFilterName => {
		let filt: EntInitialFilterName = _.clone(filter)
		// filt.name = form.getFieldValue(FormField.name) ?? null;
		// filt.governmentIds = form.getFieldValue(FormField.governmentIds) ?? null;
		filt.page = 1
		return filt
	}

	const searchHandleClick = () => {
		setFilter(setEntityFromFields())
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const table = (
		<div style={{ maxHeight: `${height}px`, overflow: 'auto' }}>
			<table>
				<thead>
					<tr>
						<th style={{ width: '40px' }}>#</th>
						<th>{t('general.nameKy')}</th>
						<th>{t('general.nameRu')}</th>
						<th style={{ width: '120px' }}></th>
					</tr>
				</thead>
				<tbody>
					{fetching ? (
						<tr>
							<th colSpan={5}>
								<Spin
									spinning={fetching}
									style={{
										width: '100%',
										height: '180px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								/>
							</th>
						</tr>
					) : (
						<></>
					)}
					{data?.map((item, index) => (
						<tr
							key={item.id}
							onDoubleClick={() => {
								openAddModal(item)
							}}
						>
							<td>{++index}</td>
							<td>{item?.nameKy}</td>
							<td>{item?.nameRu}</td>
							<td>
								<Flex gap='small'>
									{access && access.methodPut && (
										<Tooltip title={t('general.edit')}>
											<Button
												className='btn_edit'
												onClick={() => {
													openAddModal(item)
												}}
												type='primary'
												shape='circle'
												icon={<EditOutlined />}
											/>
										</Tooltip>
									)}
									{access && access.methodDelete && (
										<Tooltip title={t('general.delete')}>
											<Button
												className='btn_edit'
												danger
												onClick={() => {
													onDeleteRole(item)
												}}
												type='primary'
												shape='circle'
												icon={<DeleteOutlined />}
											/>
										</Tooltip>
									)}
								</Flex>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)

	return (
		<>
			<PageHeader
				title={t('titles.roles')}
				additionalInfo={
					<Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type='secondary'>
						{t('role.desc_role')}{' '}
					</Typography.Text>
				}
			/>
			{access && access.methodPost && (
				<Button
					type='primary'
					icon={<PlusOutlined />}
					onClick={() => {
						openAddModal(new EntRole())
					}}
				>
					{t('role.add_role')}
				</Button>
			)}
			<ContentPart setHeight={setHeight} table={table} />

			<AddRoleModal
				role={selectedRole}
				show={showModal}
				onHide={() => {
					setShowModal(false)
				}}
				onSubmit={selectedRole.id !== 0 ? onEditRole : onAddRole}
			/>
			{contextHolder}
		</>
	)
}
